// extracted by mini-css-extract-plugin
module.exports = {"container":"modal-selection_container__7VzGH"};